import request from "@/utils/request.js";

/**
 * 获取课程介绍
 * @param params
 * @returns {AxiosPromise}
 */
export function getCourseDetails(params) {
  return request({
    closeLoading: true,
    url: "/studyService/api/app/course/get",
    method: "post",
    data: params
  });
}

/**
 * 获取课程介绍(新2020-08-07)
 * @param params
 * @returns {AxiosPromise}
 */
export function getH5CourseIntroduce(params) {
  return request({
    closeLoading: true,
    url: "/studyService/api/h5/course/getH5CourseIntroduce",
    method: "post",
    data: params
  });
}

/**
 * 记录分享页访问者与推荐码的关系。该请求静默执行，不影响页面主流程。
 */
export function submitReferralRelation(referrerCode) {
  return request({
    closeLoading: true,
    closeInterceptors: true,
    closeNetworkError: true,
    url: "/operateService/api/h5/referral/relations",
    method: "post",
    data: { referrerCode }
  });
}
/**
 * @param params
 * @returns {AxiosPromise}
 */
export function checkAlertByCourseId(params) {
  return request({
    closeLoading: true,
    url: "/operateService/api/app/popupwin/checkAlertByCourseId",
    method: "post",
    data: params
  });
}




/**
 * 订阅/取消订阅课程
 *
 * @param params
 * @returns {AxiosPromise}
 */
export function subscibe(params) {
  return request({
    url: "/studyService/api/app/course/subscibe",
    method: "post",
    data: params
  });
}

/**
 * 根据技能标签id获取运营课程id
 *
 * @param params
 * @returns {AxiosPromise}
 */
export function getCourseIdBySkillTagId(params) {
  return request({
    url: "/studyService/api/h5/course/getCourseIdBySkillTagId",
    method: "post",
    data: params
  });
}

/**
 * 获取用户课程权限信息
 *
 * @param params
 * @returns {AxiosPromise}
 */
export function getCourseValidityInfo(params) {
  return request({
    closeLoading: true,
    url: "/studyService/api/app/course/getCourseValidityInfo",
    method: "post",
    data: params
  });
}

//领取指定课程的优惠卷
export function receiveCourseCoupon(commodityId) {
  return request({
    closeLoading: true,
    url: "/operateService/api/app/couponApp/receiveCourseCoupon",
    method: "post",
    data: {commodityId}
  });
}



export function getCourseIdBuoy(params) {
  return request({
    closeLoading: true,
    url: "/operateService/api/app/buoy/getCourseIdBuoy",
    method: "post",
    data: params
  });
}
